import * as PIXI from 'pixi.js';
import { AssetLoader } from './assetLoader';
import {Game} from './game.js';

export function initializePixi(container) {
  const app = new PIXI.Application({
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundColor: 0xffffff,
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
  });

  container.appendChild(app.view);
  app.renderer.events.cursorStyles.pointer = 'pointer';

  const assetLoader = new AssetLoader(app);

  assetLoader.loadAll((sheets) => {
    const game = new Game(app, assetLoader);
    // Expose restartGame on app for SymbolManager
    app.restartGame = () => game.restartGame();
    // Expose game instance for credits management
    app.gameInstance = game;
    if (typeof window !== 'undefined') window.gameInstance = game;
    // Initialize the game after assets are loaded
    game.initialize();
  });
  return app;
}